<div [class.py-2]="onlyLabel" [class.py-3]="!onlyLabel">
  @if (onlyLabel) {
    <div class="flex align-items-center gap-2">
      <i class="pi pi-lock"></i>
      <div>
        {{ label | translate }}
      </div>
    </div>
  } @else {
    <p-card>
      @if (headerLabel) {
        <ng-template #title> {{ headerLabel | translate }} </ng-template>
      }
      <div class="flex align-items-center gap-2">
        <i class="pi pi-lock"></i>
        <div>
          {{ label | translate }}
        </div>
      </div>
      <ng-template #footer>
        <div class="flex gap-2 mt-1">
          <p-button [label]="'GET_PRO_VERSION' | translate" styleClass="p-button-outlined"
                    routerLink="/frontend/player/profile/account/payments"/>
        </div>
      </ng-template>
    </p-card>
  }
</div>
